import React from 'react'
import type { CardStylingProps } from './Card'

export const CardContext = React.createContext<CardStylingProps>(
    {} as CardStylingProps
)
